export const FOOTER = 'FOOTER';
export const ERRORS = 'ERRORS';
export const RESET = 'RESET';
export const OPTIONS = 'OPTIONS';
export const IMAGE = 'IMAGE';
